
export class MemoVacationRequest {
  employeeCode: string;
  startDate: Date;
  endDate: Date;
  noteFromRequester: string;
}
